<template>
  <div class="w-100 h-100" style="position: relative;">
    <div class="w-100 video-container-position">
      <youtube
        style="width: 100%; height: 100%;"
        :fitParent="true"
        :resize="true"
        :video-id="youtubeID"
        :player-vars="options"
        :ref="youtubeID"
        @playing="youTubeVideoPlaying"
        @paused="youTubeVideoPaused"
        @ended="youtubeVideoEnded"
        @error="youtubeVideoError"
        @ready="youtubeVideoReady"
      />
    </div>
    <div v-if="isVideoLoadingOrInError" class="d-flex justify-content-center align-items-center w-100 h-100 mb-2 status-container video-container-position">
      <div class="w-100 d-flex flex-column justify-content-center align-items-center">
        <v-progress-circular
            v-if="hasValidVideoID && isNotReady"
            :size="70"
            :width="7"
            :color="primaryWhiteColor"
            indeterminate
        ></v-progress-circular>
        {{ videoLoadingOrErrorStatus }}
      </div>
    </div>
  </div>
</template>

<script>
import { YOUTUBE_VIDEO_STATUSES } from "../../../utils/youtube-statuses";

// Regex Pattern for a Youtube Video ID
const YoutubeIDRegex = /^[a-zA-Z0-9_-]{11}$/;

export default {
  props: {
    youtubeID: String,
    status: String,
    activeYoutubeID: {
      type: String,
      default: null,
    },
    options: {
      type: Object,
      default: {
        start: 0,
      },
    },
    updaterHandler: {
      type: Function,
      default: () => {},
    },
    pauseYoutubeIDVideo: {
      type: Function,
      default: () => {},
    }
  },
  data() {
    return {
      isNotReady: true,
      isError: false,
      hasValidVideoID: YoutubeIDRegex.test(this.youtubeID),
    };
  },
  computed: {
    isVideoLoadingOrInError() {
      return this.isNotReady || this.isError;
    },
    videoLoadingOrErrorStatus() {
      if(!this.hasValidVideoID) {
        return "Youtube Video ID is not valid"
      }
      if(this.isNotReady) {
        return "Loading...";
      }
      else if(this.isError) {
        return "Video is not available";
      }
      else {
        return "";
      }
    }
  },
  methods: {
    pauseYoutubeVideo(){
      this.$children[0].player.pauseVideo();
    },
    youtubeVideoReady(event) {
      // Update video loading state
      this.isNotReady = false;
    },
    youTubeVideoPlaying(event) {
      const { playerInfo: { videoData } } = event;
      const { video_id } = videoData;

      if(this.status === YOUTUBE_VIDEO_STATUSES.RESET) {
        this.updaterHandler(video_id);
        return;
      }

      if(this.activeYoutubeID !== video_id) {
        if(this.activeYoutubeID) {
          // For a different selected youtubeID, pause the currently played youtube video
          this.pauseYoutubeIDVideo(this.activeYoutubeID);
        }

        this.$emit('changeYoutubeVideoPlay', video_id);
      }

      // Update the asset items related to the youtube video
      this.updaterHandler(video_id, YOUTUBE_VIDEO_STATUSES.PLAYING, this.options.start);
    },
    youTubeVideoPaused(event) {
      const { playerInfo: { videoData } } = event;
      const { video_id } = videoData;

      // The exact time the current video was paused
      const currentTime = event.getCurrentTime();

      // Update the asset items related to the youtube video
      this.updaterHandler(video_id, YOUTUBE_VIDEO_STATUSES.PAUSED, currentTime);
    },
    youtubeVideoEnded(event) {
      const { playerInfo: { videoData } } = event;
      const { video_id } = videoData;

      const player = this.$refs[video_id].player;
      player.seekTo(0, false);
      player.stopVideo();

      // Update the asset items related to the youtube video
      this.updaterHandler(video_id, YOUTUBE_VIDEO_STATUSES.RESET);
    },
    youtubeVideoError(event) {
      // Update video error state
      this.isError = true;
    },
  },
}
</script>

<style scoped>
.status-container {
  border-radius: 5px;
  border: 2px solid #000000;
  font-size: clamp(16px, 2vw, 24px);
  font-weight: bold;
  color: #ffffff;
  font-family: Rajdhani;
  text-align: center;
  background-color: #000000;
  z-index: 100;
}
.video-container-position {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>